
import { SMApp } from "@/store";
import { computed, defineComponent, getCurrentInstance, onMounted, onUnmounted } from "vue-demi";

export default defineComponent({
  name: "VDocuments",

  components: {
    DocumentTaskTemplate: () => import("@/modules/Documents/DocumentTaskTemplate.vue"),
    ActionButtonsV2: () => import("@/components/ActionContainer/ActionButtonsV2.vue"),
  },

  setup() {
    const instance = getCurrentInstance()?.proxy;
    const route = instance?.$route;

    const directoryId = computed(() => Number(route.params.directoryId || 0));

    const fileType = computed(() => route.params.fileType || "default");

    const caseId = computed(() => Number(route.params.id ?? 0));

    const isCase = computed(() => !!caseId.value);

    const isParsedFileType = computed(() => {
      return ["cos", "ielts", "pte"].includes(fileType.value);
    });

    const pageTitle = computed(() => {
      return isParsedFileType.value ? "Reupload a Document" : "Upload Document(s)";
    });

    onMounted(() => {
      SMApp.setPageTitle(pageTitle.value);

      const backLink = route.path.replace(/\/upload\b.*$/, "");

      SMApp.setBackLink(backLink);
    });

    onUnmounted(() => {
      SMApp.setBackLink("");
    });

    return {
      directoryId,
      fileType,
      isCase,
      pageTitle,
    };
  },
});
